import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components/macro";

import { Clickable } from "components/Button";
import { Row } from "components/Layout";

const CircleSidebarButton = styled(Row)(
  ({
    theme,
    background = "primary",
  }: {
    theme: { colors: string };
    background?: string;
  }) => `
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${theme.colors[background]};
`,
);

const ButtonText = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 32px;
`;

interface SidebarButtonProps {
  icon: IconDefinition;
  background?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const SidebarButton = ({
  icon,
  background,
  onClick,
  children,
}: SidebarButtonProps) => {
  return (
    <Clickable onClick={onClick} data-tour={children}>
      <Row alignCenter>
        <CircleSidebarButton background={background}>
          <FontAwesomeIcon icon={icon} style={{ fontSize: "18px" }} />
        </CircleSidebarButton>
        <ButtonText>{children}</ButtonText>
      </Row>
    </Clickable>
  );
};
